import React, { useEffect, useState } from 'react';
import { getExtraRevenues, deleteExtraRevenues } from '~/services/hooks/extraRevenues';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { useTranslation } from 'react-i18next';
import Button from '~/components/Button';
import ExtraRevenuesModal from './form';
import { useCheckAuth } from '~/components/Can/checkAuth';
import ColButton from '~/components/ColButton';
import IsMobile from '~/services/mobileCheck';
import ExtraRevenueView from './view';
import { extraRevenuesColumns } from '~/tables/extraRevenues';
import errorHandler from '~/Utils/errorHandler';

export default function ExtraRevenues() {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [extraRevenuesEdit, setExtraRevenuesEdit] = useState({});
  const [ModalVisible, setModalVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getExtraRevenues(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = async (record, view = false) => {
    setExtraRevenuesEdit(record);
    view ? setViewVisible(true) : setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteExtraRevenues(id);
      fetchData();
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage, search]);

  return (
    <Box>
      <ColButton>
        <Button color="primary" onClick={() => handleEdit(null)} disabled={!authCheck('@extras/create')}>
          {t('screens:extraRevenues.addExtraRevenues')}
        </Button>
      </ColButton>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={extraRevenuesColumns(handleEdit, handleDelete, isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <Global />
      <ExtraRevenueView
        visible={viewVisible}
        extraRevenue={extraRevenuesEdit}
        isMobile={isMobile}
        onClose={() => {
          setViewVisible(false);
          setExtraRevenuesEdit(null);
        }}
      />
      <ExtraRevenuesModal
        visible={ModalVisible}
        extraRevenuesEdit={extraRevenuesEdit}
        isMobile={isMobile}
        onClose={() => {
          setModalVisible(false);
          setExtraRevenuesEdit(null);
          fetchData();
        }}
      />
    </Box>
  );
}
